import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpResponse, HttpRequest, HttpHandler, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { config } from '../../../../config/pages-config';
import { environment } from '../../../../environments/environment';
import { CustomErrorHandlerService } from '@vfde-fe/ngx-lib/services/custom-error-handler';
import { RouterService } from '../router.service';
import { SpinnerService, SpinnerLoader } from '@vfde-fe/ngx-lib/components/spinner';
import { CoreAuthenticationService } from '@vfde-fe/ngx-lib/services/core-authentication';
import { catchError , map } from 'rxjs/operators';
import {  API_KEY_HEADERS_FORMCENTER_PREPROD, API_KEY_HEADERS_FORMCENTER_PROD,
    Ignore_General_Error, Stop_Failure_Tracking, Ignore_Tracking } from 'src/app/common/constants/Defines';
import { RoutesUtilsService } from '@vfde-fe/ngx-lib/services/routes-utils';
import { DXL_API_URLS } from '@vfde-fe/ngx-lib/core';

/**
 * HTTPClientInterceptor
 */
@Injectable()
export class HTTPClientInterceptor implements HttpInterceptor {
    /** pages */
    public pages;
    /** pagesConfig */
    private pagesConfig: any;
    /** loader */
    private loader: SpinnerLoader = null;

    /**
     *
     * @param routerService
     * @param routesUtilsService
     * @param customErrorHandlerService
     * @param spinnerService
     * @param authenticationService
     */
    public constructor (
        private routerService: RouterService,
        private routesUtilsService: RoutesUtilsService,
        private customErrorHandlerService: CustomErrorHandlerService,
        private spinnerService: SpinnerService,
        private authenticationService: CoreAuthenticationService) {

        this.pagesConfig = config;

    }
    /**
     * intercept
     * @param httpRequest
     * @param next
     * @returns
     */
    public intercept (request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const data = request.url.startsWith('{') ? JSON.parse(request.url) : null;
        const headerConfig = {};
         if (data) {
          if(data.api_name !== DXL_API_URLS.UPLOAD_FILE.UPLOAD_FILE_GET.api_name || DXL_API_URLS.UPLOAD_FILE.FILE_STATUS_GET.api_name)
            headerConfig['wf-api-name'] =  data.api_name;

           request = request.clone({url: data.url});
        }

        if (request.url.indexOf(environment.baseUrlDxlPreProdFullPath) !== -1) {
            headerConfig['x-api-key'] =   API_KEY_HEADERS_FORMCENTER_PREPROD;
        } else if (request.url.indexOf(environment.baseUrlDxlProd) !== -1) {
            headerConfig['x-api-key'] =   API_KEY_HEADERS_FORMCENTER_PROD;
           }

       return this.processConnection(request, next, headerConfig);
    }

     /**
      * getConnection
      * @param {Request} request
      */
      public processConnection (request: HttpRequest<any>, next: HttpHandler, headerConfig) {
        const disableSpinner = request.headers.get('disableSpinner') === 'true' || request.headers.get('disablespinner') === 'true';
        const loader: SpinnerLoader = !disableSpinner ? this.spinnerService.startLoader() : null;
        request =  request.clone({setHeaders: headerConfig});

        // const connection: XHRConnection = super.createConnection(request);
        return next.handle(request).pipe( map((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              if (loader) {
                  this.spinnerService.endLoader(loader, true);
              }
            }

            return event;
          }), catchError((error: HttpErrorResponse) => {
              const skipGeneralError = request.headers.get(Ignore_General_Error);
              const stopFailureTracking = request.headers.get(Stop_Failure_Tracking);
              const ignoreTracking = request.headers.get(Ignore_Tracking);
              if (loader) {
                  this.spinnerService.endLoader(loader, false);
              }
              if (skipGeneralError) {
                  return this.processErrorResponse(error, skipGeneralError, request.headers.get('wf-api-name'), !!stopFailureTracking, request.method, !!ignoreTracking);
              }

              return this.processErrorResponse(error, null, request.headers.get('wf-api-name'), !!stopFailureTracking, request.method, !!ignoreTracking);
          }));

     }

    /**
     * processErrorResponse to handle generic error on level of application (404,500,401,403,etc..)
     */
    /** processErrorResponse */
    public processErrorResponse (response: HttpErrorResponse, skipGeneralError ?: string, trackingLocation ?: string, stopFailureTracking?: boolean, httpMethod?: string, ignoreTracking?: boolean) {
        let errorCode = null;

        try {
            if (response.url.indexOf(environment.baseUrlDxl) !== -1 || response.url.indexOf(environment.baseUrlDxlProd) !== -1 || response.url.indexOf(environment.baseUrlDxlPreProd) !== -1) {
                errorCode = response.error ? response.error.code : null;
            } else {
                errorCode = response.error.operationError ? response.error.operationError.code : null;
              }
        } catch (e) {
            return throwError(response);
            // do nothing and not to stop code sequence in case response in not in JSON format
          }
          if (response.url.indexOf(environment.cmsConfigPath) > -1 || response.url.indexOf(environment.cmsErrorMessagesPath) > -1 || response.url.indexOf(environment.cmsCommonWording) > -1) {
            return throwError(response);
        }

        if(response.status){
          const currentModule = this.routerService.getCurrentModule() !== '' ? this.routerService.getCurrentModule() : undefined;
          const trackError = ignoreTracking ? false : true;
          this.customErrorHandlerService.getErrorDescription(currentModule, errorCode, response.status.toString(), trackError, skipGeneralError === 'true' ? false : true, false, this.routesUtilsService.getCurrentUsecase(), '', trackingLocation, null, stopFailureTracking, httpMethod);

          return  throwError(response);
        }
    }

}
